import React from 'react'
import { withRouter } from 'react-router-dom'
import { PropTypes } from 'prop-types'
import logger from '../../utils/logger'

class ErrorPage extends React.Component {
  componentDidMount() {
    const { setHeader } = this.props
    setHeader()

    this.logError()
  }

  logError = () => {
    const errMessage = `An error occurred in page ${document.referrer}`
    logger.logError(errMessage)
  }

  render() {
    return (
      <div className="dsib-errorPage">
        <div className="dsib-errorPage__content">
          <div className="dsib-errorPage__hero">
            <img
              src="/baguette-background-min.png"
              alt=""
              className="dsib-errorPage__image"
            />
            <div className="dsib-errorPage__text">
              <h1 className="dsib-errorPage__title">
                Oh,
                <br />
                crumbs!
              </h1>
              <p className="dsib-errorPage__message">
                Something&apos;s gone wrong, go back to try again.
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ErrorPage.propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired
  }).isRequired,
  setHeader: PropTypes.func.isRequired,
}

export default withRouter(ErrorPage)
